module.exports = {"id":"164853","name":"Adam Federici","rating":"72","photo":"./data/images/photos/2/164853.png","club":{"name":"Bournemouth","logo":"./data/images/clubs/Bournemouth.png"},"positions":["G"],"photoFolderIndex":2}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/AdamFederici0.json
// module id = 74
// module chunks = 0